<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment" style="margin-top: 150px;">
<p style="text-align: center;">Thus, I set Pen to Paper with delight</p>
<p style="text-align: center;">And quickly had my thoughts in black and white,</p>
<p style="text-align: center;">For having now my method by the end,</p>
<p style="text-align: center;">Still as I pull’d, it came; and so I penn’d</p>
<p style="text-align: center;">It down; until it came at last to be</p>
<p style="text-align: center;">For length and breadth, the bigness which you see.</p><br/>
<p style="text-align: center;">From: <em>The Pilgrim’s Progress</em></p>
<p style="text-align: center;">By John Bunyan, in <em>The Author’s Apologue</em></p>
<p style="text-align: center;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?503d06bc